export const objectKeysToLowerCase = (origObj: any): any => {
	return Object.keys(origObj).reduce((newObj: any, key) => {
		const val = origObj[key];
		const isObject = !!val && typeof val === 'object' && typeof val.getMonth !== 'function';
		const newVal = isObject ? objectKeysToLowerCase(val) : val;

		newObj[key.toLowerCase()] = newVal;

		return newObj;
	}, {});
};
